import { AutocompleteOption, AutocompleteOptionsRecord } from './types'

/**
 * Convert options to array format if they're provided as a record
 */
export function normalizeAutocompleteOptions(
  options: AutocompleteOption[] | AutocompleteOptionsRecord,
): AutocompleteOption[] {
  if (Array.isArray(options)) {
    return options
  }

  // Handle Record<string, string> format (like language maps)
  // Note that the format here is { "Language Name": "language_code" }
  return Object.entries(options).map(([label, value]) => ({
    type: 'option',
    label,
    value,
  }))
}
